module.exports = __webpack_public_path__ + "static/media/bg_avc.4970f9de.svg";